import React from "react";
import Link from "next/link";
import NavMenuItem from "./nav-menu-item";
import { Sparkles } from "lucide-react";
import ActionIcon from "./action-icon";

const SearchMenuItems = () => {
    return (
        <div className="grid">
            <div className="flex hover:custom-bg-grey-100 cursor-pointer p-4 border-t-[1px] custom-border-grey-50">
                <ActionIcon color='custom-text-grey-800'>
                    <Sparkles size={20} color="currentColor" />
                </ActionIcon>
                <Link href='/workpeg-ai' className="poppins-light custom-text-grey-500 text-[15px] ml-2">Ask Workpeg AI to do something</Link>
            </div>
            <div className="grid border-t-[1px] custom-border-grey-50">
                <span className="custom-text-grey-300  text-[12px] poppins-light px-4 pt-3 pb-2">Banking</span>
                <div className="grid">
                    <NavMenuItem icon='banknote' href="/payroll">
                        Payroll
                    </NavMenuItem>
                    <NavMenuItem icon='users-round' href="/employees">
                        Employees
                    </NavMenuItem>
                    <NavMenuItem icon='landmark' href="/remittances">
                        Remittances
                    </NavMenuItem>
                </div>
            </div>
            <div className="grid border-t-[1px] custom-border-grey-50">
                <span className="custom-text-grey-300  text-[12px] poppins-light px-4 pt-3 pb-2">Banking</span>
                <div className="grid">
                    <NavMenuItem icon='banknote' href="/payroll">
                        Payroll
                    </NavMenuItem>
                    <NavMenuItem icon='users-round' href="/employees">
                        Employees
                    </NavMenuItem>
                </div>
            </div>
            <div className="grid border-t-[1px] custom-border-grey-50">
                <span className="custom-text-grey-300  text-[12px] poppins-light px-4 pt-3 pb-2">Banking</span>
                <div className="grid">
                    <NavMenuItem icon='banknote' href="/payroll">
                        Payroll
                    </NavMenuItem>
                    <NavMenuItem icon='users-round' href="/employees">
                        Employees
                    </NavMenuItem>
                </div>
            </div>
            <div className="grid border-t-[1px] custom-border-grey-50">
                <span className="custom-text-grey-300  text-[12px] poppins-light px-4 pt-3 pb-2">Banking</span>
                <div className="grid">
                    <NavMenuItem icon='banknote' href="/payroll">
                        Payroll
                    </NavMenuItem>
                    <NavMenuItem icon='users-round' href="/employees">
                        Employees
                    </NavMenuItem>
                </div>
            </div>
            <span className="custom-text-grey-200  p-4 poppins-light border-t-[1px] custom-border-grey-50 text-[14px]">Employee Name</span>
        </div>
    )
};

export default SearchMenuItems;
